import { SVGProps } from 'react'
import {
  BitcoinLargeIcon,
  ChainLinkIcon,
  DaiIcon,
  DemoBitcoinIcon,
  EthereumIcon,
  PaxosStandartIcon,
  PolygonIcon,
  ShibaInuIcon,
  TetherIcon,
  TronIcon,
  UsdCoinIcon,
  UsdcPolygonIcon,
  UsdtPolygonIcon,
  UsdttIcon,
  UstIcon,
  WrappedBitcoinIcon,
} from '../assets/svg'

import POLUSD from '../assets/svg/Sticky/POLUSD'

export const CURRENCIES = {
  BTC: 'BTC',
  ETH: 'ETH',
  USDC: 'USDC',
  WBTC: 'WBTC',
  USDT: 'USDT',
  DAI: 'DAI',
  LINK: 'LINK',
  PAX: 'PAX',
  DEMO: 'DEMO',
  T_USDT: 'T_USDT',
  SHIB: 'SHIB',
  TRX: 'TRX',
  UST: 'UST',
  MATIC: 'MATIC',
  P_USDT: 'P_USDT',
  P_USDC: 'P_USDC',
  SOL: 'SOL',
  S_USDT: 'S_USDT',
  S_USDC: 'S_USDC',
  MATIC_ERC: 'MATIC_ERC',
  MRX: 'MRX',
  LTC: 'LTC',
  AVAX: 'AVAX',
  A_USDT: 'A_USDT',
  A_USDC: 'A_USDC',
  T_USDC: 'T_USDC',
  BNB: 'BNB',
  B_USDT: 'B_USDT',
  B_USDC: 'B_USDC',
  BCH: 'BCH',
  B_BUSD: 'B_BUSD',
  E_BUSD: 'E_BUSD',
  P_BUSD: 'P_BUSD',
  A_BUSD: 'A_BUSD',
  XRP: 'XRP',
  TON: 'TON',
  STMATIC: 'STMATIC',
  STETH: 'STETH',
  ALL_USDC: 'ALL_USDC',
  ALL_USDT: 'ALL_USDT',
  ALL_BUSD: 'ALL_BUSD',
  ALL_ETH: 'ALL_ETH',
  ALL_MATIC: 'ALL_MATIC',
  ALL_TUSD: 'ALL_TUSD',
  ARB_ARB: 'ARB_ARB',
  ARB_ETH: 'ARB_ETH',
  T_USDD: 'T_USDD',

  ALL_POL: 'ALL_POL',
  POL: 'POL',
  STPOL: 'STPOL',
  POL_ERC: 'POL_ERC',
}

export const CURRENCIES_ICON: { [key: string]: (props: SVGProps<SVGSVGElement>) => JSX.Element } = {
  [CURRENCIES.BTC]: BitcoinLargeIcon,
  [CURRENCIES.WBTC]: WrappedBitcoinIcon,
  [CURRENCIES.ETH]: EthereumIcon,
  [CURRENCIES.USDT]: TetherIcon,
  [CURRENCIES.USDC]: UsdCoinIcon,
  [CURRENCIES.DAI]: DaiIcon,
  [CURRENCIES.LINK]: ChainLinkIcon,
  [CURRENCIES.PAX]: PaxosStandartIcon,
  [CURRENCIES.DEMO]: DemoBitcoinIcon,
  [CURRENCIES.T_USDT]: UsdttIcon,
  [CURRENCIES.SHIB]: ShibaInuIcon,
  [CURRENCIES.TRX]: TronIcon,
  [CURRENCIES.UST]: UstIcon,
  [CURRENCIES.MATIC]: PolygonIcon,
  [CURRENCIES.P_USDC]: UsdcPolygonIcon,
  [CURRENCIES.P_USDT]: UsdtPolygonIcon,

  [CURRENCIES.ALL_POL]: POLUSD,
  [CURRENCIES.POL]: POLUSD,
  [CURRENCIES.STPOL]: POLUSD,
  [CURRENCIES.POL_ERC]: POLUSD,
}
